import {findPasswordError} from '../../configurations/utilities';

export function userInputPassword() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            existingAccount: '=',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/directives/userInputs/userInputPassword.html',
        controller: [
            '$scope', function($scope) {
                $scope.password = '';
                $scope.passwordRepeat = '';

                $scope.password1Error = null;
                $scope.password2Error = null;

                $scope.passwordWasCorrect = false;

                // we want to listen for any change to the repeat input so we can show the next button as soon as
                // possible but we don't want errors popping up every step of the way - so what we do here is check the
                // passwords every step and if they've never matched before, we remove any errors that may have been
                // assigned only once they do match do we decide it's ok to show errors on that second input
                $scope.handleChange = function() {
                    $scope.checkPasswords();
                    if ($scope.password2Error && !$scope.passwordWasCorrect) {
                        $scope.password2Error = null;
                    }
                };

                $scope.checkPasswords = function(skipPW2Error) {
                    var pw1 = $scope.password;
                    var pw2 = $scope.passwordRepeat;

                    $scope.password1Error = findPasswordError(pw1);
                    $scope.password2Error = null;

                    if (skipPW2Error === true && !pw2) {
                        return;
                    }

                    if (!$scope.password1Error && pw1 !== pw2) {
                        $scope.password2Error = 'Passwords do not match';
                    }

                    if (!$scope.password1Error && !$scope.password2Error) {
                        $scope.passwordWasCorrect = true;
                        $scope.data.set('password', pw1);
                    } else {
                        $scope.data.set('password', null);
                    }
                };

                $scope.$on('showErrors', $scope.checkPasswords);
            },
        ],
    };
}

